export function dateFormat(dateString) {

  // Check if dateString is empty or not a valid date
  if (!dateString || isNaN(Date.parse(dateString))) {
    return "-"; // Return empty string if dateString is empty or not a valid date
  }

  const date = new Date(dateString);
  const formattedDate = date
    .toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    })
    .replace(/(\d+)\/(\d+)\/(\d+)/, (match, month, day, year) => {
      // Rearrange the date format to month day and year
      return `${month}-${day}-${year}`;
    });
  return formattedDate;
}

export function dateTimeFormat(dateString) {
  // Check if dateString is empty or not a valid date
  if (!dateString || isNaN(Date.parse(dateString))) {
    return "-"; // Return "-" if dateString is empty or not a valid date
  }

  const date = new Date(dateString);
  const formattedDateTime = date
    .toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
    .replace(/(\d+)\/(\d+)\/(\d+), (\d+):(\d+) (AM|PM)/, (match, month, day, year, hour, minute, period) => {
      // Rearrange the date format to month-day-year and add time
      return `${month}-${day}-${year} ${hour}:${minute} ${period}`;
    });

  return formattedDateTime;
}

export function formatToYyyyMmDd(dateString) {
  if (!dateString || isNaN(Date.parse(dateString))) {
    return ""; // Return empty string if dateString is empty or not a valid date
  }
  const date = new Date(dateString);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export const handleKeyNumberPress = (event) => {
  const enteredKey = event.key;
  if (!/^[0-9]$/.test(enteredKey)) {
    event.preventDefault();
  }
};

export function dateFormatYYYY(dateString) {

  // Check if dateString is empty or not a valid date
  if (!dateString || isNaN(Date.parse(dateString))) {
    return ""; // Return empty string if dateString is empty or not a valid date
  }

  const date = new Date(dateString);
  const formattedDate = date
    .toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    })
    .replace(/(\d+)\/(\d+)\/(\d+)/, (match, month, day, year) => {
      // Rearrange the date format to month day and year
      return `${year}`;
    });
  return formattedDate;
}

export function datetoTimestampFormat(dateString) {

  // Check if dateString is empty or not a valid date
  if (!dateString || isNaN(Date.parse(dateString))) {
    return 0; // Return empty string if dateString is empty or not a valid date
  }

  const date = new Date(dateString);
  const formattedDate = date.getTime();
  return formattedDate;
}